import Vue from 'vue'
import moment from 'moment'
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css';

import router from './config/router';
import store from './config/store';
import './config/components'
import './config/filters'

Date.prototype.toJSON = function(){ return moment(this).format(); }

import security from './utils/security';
security.setupAuth();

Vue.use(BootstrapVue);

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js